import type { GroupedTask, MinifiedTask } from '@gcv/shared';
import { TaskInternalExternal, TaskStatus } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { TasksApi } from 'api/TasksApi';
import { BANK_TASKS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export interface BankTasksOptions {
  direction?: TaskInternalExternal;
  enabled?: boolean;
}

export function useBankTasks(startDate: string, endDate: string, options?: BankTasksOptions) {
  const direction = options?.direction ?? TaskInternalExternal.EXTERNAL;
  const { userBankId } = useUser();
  const tasksApi = new TasksApi();

  const { data: bankTasks, isLoading: isLoadingBankTasks } = useQuery<(MinifiedTask | GroupedTask)[]>({
    enabled: !!userBankId && (options?.enabled ?? true),
    queryKey: [BANK_TASKS_KEY, userBankId, direction, startDate, endDate],
    queryFn: async () => {
      const response = await tasksApi.getBankTasksV2(userBankId, userBankId, direction, startDate, endDate, [
        TaskStatus.OPEN,
        TaskStatus.COMPLETE,
        TaskStatus.SUPPRESSED,
        TaskStatus.PROCESSING
      ]);
      return response.tasks;
    },
    meta: {
      snackbarErrorMessage:
        'There was an issue loading tasks. Please contact support if the problem persists.'
    }
  });

  return { bankTasks, isLoadingBankTasks };
}
